import request from '@/utils/axios'

// 获取登录历史
export function ajax_loginlog(data) {
  return request({
    url: '/member/getLoginRecord',
    method: 'POST',
    data
  })
}

// 得到常用地列表
export function ajaxGet_getOftenIP(data) {
  return request({
    url: '/member/getIpAddr',
    method: 'get'
  })
}

// 获取安全设置记录
export function ajax_security_set_log(data) {
  return request({
    method: 'post',
    url: '/userCenter/securityRecord',
    data
  })
}

// 获取用户常用地址IP
export function ajax_commonAddress() {
  return request({
    method: 'get',
    url: '/member/getIpAddr'
  })
}

// 上传身份证图片的接口
export function ajax_upload_idcard(files) {
  let uploadArr = files.map((file) => {
    let formData = new FormData()
    formData.append('file', file)
    formData.append('type', 2)
    return request({
      method: 'post',
      // url: 'http://192.168.1.29:8003/upload/api/upload',
      url: `${process.env.VUE_APP_UPLOAD}/upload/api/upload`,
      data: formData
    })
  })

  return Promise.all(uploadArr)
}

// 修改登录密码
export function ajax_modifyLoginPassword(data) {
  return request({
    method: 'post',
    url: '/userCenter/resetLoginPassword',
    data
  })
}

// 请求实名认证的接口
export function ajax_realname_auth(userInfo) {
  return request({
    method: 'post',
    url: '/member/approve/real/name',
    data: userInfo
  })
}

// 发送邮箱验证码
export function ajax_sendEmailSms(data) {
  return request({
    method: 'post',
    url: '/member/email/code',
    data
  })
}

// 发送验证码
export function ajax_sendSms(data) {
  return request({
    method: 'post',
    url: '/userCenter/getAuthCode',
    data
  })
}

// 设置资金密码
export function ajax_setFundPass(data) {
  return request({
    method: 'post',
    url: '/userCenter/resetTradePassword',
    data
  })
}

// 获取可注册的国家信息
export function ajax_getContry() {
  return request({
    method: 'post',
    url: '/userCenter/getNationalList'
  })
}

// 绑定手机号的接口
export function ajax_bindPhone(data) {
  return request({
    method: 'post',
    url: '/userCenter/bindPhone',
    data
  })
}

// 更换手机号
export function ajax_modifyPhone(data) {
  return request({
    method: 'post',
    url: '/member/approve/update/phone',
    data
  })
}

// 绑定邮箱
// {
//   "email": "1498711500@qq.com",
//   "smsCode": "820252",
//   "emailCode": "115386",
//   "googleCode": ""
// }
export function ajax_bindEmail(data) {
  return request({
    method: 'post',
    url: '/userCenter/bindEmail',
    data
  })
}

// 开启关闭验证状态
// {
//   "type": 0,   //类型  0：手机验证 1：谷歌验证 2; 邮箱验证
//   "status": 0,   // 是否开启  0:false 1: true
//   "smsCode": "588326",
//   "emailCode": "534591",
//   "googleCode": "955637"
// }
export function ajax_switchSafeVerify(data) {
  return request({
    method: 'post',
    url: '/member/approve/close/ver',
    data
  })
}

// 获取 google 验证 key
export function ajax_getGoogleKey() {
  return request({
    method: 'get',
    url: '/member/approve/get/secretKey'
  })
}

// 绑定 google 验证
export function ajax_bindGoogleVerify(googleCode) {
  return request({
    method: 'post',
    url: '/member/approve/bind/secretKey',
    data: { googleCode }
  })
}

// 开启或者关闭安全验证
//     type: 1, // 类型  0：手机验证 1：谷歌验证 2; 邮箱验证
//     status: 1, // 是否开启  0:false 1: true
//     smsCode: '588326',
//     emailCode: '534591',
//     googleCode: '955637'
export function ajax_openOrCloseSafeVerify(data) {
  return request({
    method: 'post',
    url: '/member/approve/close/ver',
    data
  })
}

// 获取用户常用地
export function ajax_getUserOftenAddress() {
  return request({
    method: 'get',
    url: '/member/getIpAddr'
  })
}

// 删除常用地
export function ajax_delOftenAddress(id) {
  return request({
    method: 'post',
    url: '/member/updateIpAddr',
    data: {
      id: id
    }
  })
}

// 查询用户信息
export function ajax_getUserInfo() {
  return request({
    method: 'post',
    url: '/userCenter/userSetInfo'
  })
}

// 查询认证信息
export function ajax_getAuthInfo() {
  return request({
    method: 'get',
    url: '/member/approve/realApprove'
  })
}

// 下载照片
export function ajax_downloadFile(path) {
  return request({
    method: 'post',
    url: 'http://192.168.1.9:8003/api/download',
    responseType: 'blob',
    params: {
      path
    }
  })
}

// 提交KYC1认证
export function doCommitC1Auth(data) {
  return request({
    method: 'post',
    url: '/userCenter/addC1Auth',
    data
  })
}
// 提交KYC2认证
export function doCommitC2Auth(data) {
  return request({
    method: 'post',
    url: '/userCenter/addC2Auth',
    data
  })
}
// 提交KYC3认证
export function doCommitC3Auth(data) {
  return request({
    method: 'post',
    url: '/userCenter/addC3Auth',
    data
  })
}
